import Tooltip from '~/components/Tooltip';
import InfoIcon from '~/components/icons/InfoIcon';

const InputLabel = ({ children, message, showTooltip = false }) => {
  return (
    <div className="input-label flex items-center gap-[6px] mt-4">
      {children}
      {showTooltip && message && (
        <Tooltip message={message} tooltipId="label-tooltip">
          <InfoIcon />
        </Tooltip>
      )}
    </div>
  );
};

export default InputLabel;